import React from "react"
// react component for creating dynamic tables
import ReactTable from "react-table"

import * as Alert from "alertService"
import { APIPost, APIGet } from "services/APIRequest"
import UrlServer from "configs/UrlServer"
import { ErrorsCallback, SuccessCallback } from "alertService"
import { thaiBath } from "helpers/ConvertFormat"
import { arrayObject, arrayTypeKeyObject } from "helpers/ConvertKey"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsUserFromImportUpdate } from "store/actions"

import ConfigHost from "services/ConfigHost"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteIcon from '@material-ui/icons/Delete';
// core components
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import Switch from "@material-ui/core/Switch"
import Badge from "components/Badge/Badge"
import Tooltip from "@material-ui/core/Tooltip";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle"
import tasksStyle from "assets/jss/material-dashboard-pro-react/components/tasksStyle";
const styles = {
  ...extendedFormsStyle,
  ...tasksStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  noConfirmedemail: {
    color: "red"
  },
  devType: {
    color: "#689F38"
  },
  tableH: {
    // marginTop: "30px",
    // marginBottom: "30px"
  }
}
class UserFromImportListManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      userTypeKey: {},
      statusWaitingUpdate: true,
      dataListRaw: [],
      dataList: []
    }
  }
  componentDidMount() {
    APIGet(UrlServer.URL_GET_USER_TYPE, ({ datas }) => {

      const user_type = arrayTypeKeyObject(datas, "code")
      this.setState({
        userTypeKey: user_type
      }, () => {
        this.props.listsUserFromImportUpdate()
      })
    })
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.listsUserFromImport !== nextState.dataListRaw) {
      var dataList = this.renderListData(nextProps)
      this.setState({
        statusWaitingUpdate: false,
        dataListRaw: nextProps.listsUserFromImport,
        dataList: dataList
      }, () => {
        Alert.LoadingClose()
      })
    }
  }

  handleUserViewDetail = (indexData) => {
    this.props.callbacksetTabIndex(1)
    this.props.callbackSetCurrentData(this.state.dataListRaw[indexData])
  }

  renderListData = data => {
    return data.listsUserFromImport.map((CData, key) => {
      return {
        id: (key + 1),
        first_name: CData.user_data_id ? CData.user_data_id.first_name : "",
        last_name: CData.user_data_id ? CData.user_data_id.last_name : "",
        election_list: CData.election_list_status ? "yes" : "",
        url: ConfigHost.MY_APP_PUBLIC_IP + "pr/" + CData.uniqcode,
        active: (
          <div className="actions-right">
            <Tooltip
              id="tooltip-top"
              title={((CData.active) ? "ปิด" : "เปิด") + " การใช้งานข้อรหัสนี้"}
              placement="top"
              classes={{ tooltip: this.props.classes.tooltip }}
            >
              <Switch
                checked={CData.active}
                onChange={e => {
                  this.handleChangeActive(CData._id, CData.user_data_id.email, !CData.active)
                }}
                disabled={CData.user_type_code === 0 ? true : false}
                classes={{
                  switchBase: this.props.switchBase,
                  checked: this.props.switchChecked,
                  icon: this.props.switchIcon,
                  iconChecked: this.props.switchIconChecked,
                  bar: this.props.switchBar
                }}
              />
            </Tooltip>
          </div>
        ),
        actions: (
          <div className="actions-right">
            <Button
              round
              color="danger"
              className={this.props.classes.mb4}
              onClick={e => this.handleDeleteData(CData)}
            >
              <DeleteIcon className={this.props.classes.icons} />
              ลบ
            </Button>
          </div>
        ),
      }
    })
  }
  handleDownloadExcelFile = (e) => {
    Alert.QuestionCallback("คุณต้องการดาวน์โหลด Excel File ใช่หรือไม่?", "blue", () => {
      const dataToSend = {
      }
      APIPost(UrlServer.URL_POST_USER_FROM_IMPORT_DOWNLOAD, dataToSend, (datas) => {
        const response = {
          file: ConfigHost.HOST_API + "reports/" + datas.datas.fileName,
        };
        document.location = response.file
      })
    })
  }
  handleCleanData = (e) => {
    Alert.QuestionCallback("คุณยืนยันจะล้างข้อมูลที่เป็นผู้ใช้งานประเภท User ทั้งหมด? ระบบไม่สามารถกู้ข้อมูลได้ เนื่องจากไม่ได้มี function Backup data", "blue", () => {
      const dataToSend = {
      }
      APIPost(UrlServer.URL_POST_REMOVE_USER_ALL, dataToSend, (datas) => {
        this.props.listsUserFromImportUpdate()
      })
    })
  }
  handleChangeActive = (id, name, status) => {
    Alert.QuestionCallback("คุณต้องการเปลี่ยนสถานะการใช้งานของ " + name + " เป็น " + status + " ใช่หรือไม่?", "blue", () => {
      const dataToSend = {
        _id: id,
        active: status
      }
      APIPost(UrlServer.URL_AUTH_USER_SET_ACTIVE, dataToSend, (datas) => {
        this.props.listsUserFromImportUpdate()
      })
    })
  }
  handleDeleteData = (CData) => {
    Alert.QuestionCallback("คุณต้องการลบ " + CData.username + " ใช่หรือไม่?", "red", () => {
      const dataToSend = {
        user_id: CData._id,
        user_data_id: CData.user_data_id._id,
      }
      APIPost(UrlServer.URL_POST_REMOVE_USER, dataToSend, (datas) => {
        SuccessCallback(datas.message, null, () => {
          this.props.listsUserFromImportUpdate()
        })
      })
    })
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card >
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <FormatListNumberedIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>รายการ User นำเข้าระบบโดยการ Import</h4>
              </CardHeader>
              <CardBody>
                <div>
                  <Button
                    round
                    color="danger"
                    className={classes.mb4}
                    onClick={this.handleCleanData}
                  >
                    <DeleteIcon className={this.props.classes.icons} />
                    ล้างข้อมูลผู้ใช้งาน Type User ทั้งหมด
                  </Button>
                </div>
                <span >จำนวน {thaiBath(this.state.dataList.length, false)} รายการ</span>
                <br />
                <i className="txt-c-b1">Password Gen เป็นรหัสที่ตั้งให้จากระบบเมื่อ Import เข้า แต่ถ้าเปลี่ยนรหัสแล้วจะไม่สามารถใช้รหัสนี้เข้าระบบได้ ต้องแจ้ง Administrators เปลี่ยนรหัสใหม่</i>
                <ReactTable
                  className="table-scroll"
                  data={this.state.dataList}
                  filterable
                  columns={[
                    {
                      Header: "No.",
                      accessor: "id",
                      width: 60
                    },
                    {
                      Header: "First Name",
                      accessor: "first_name"
                    },
                    {
                      Header: "Last Name",
                      accessor: "last_name"
                    },
                    {
                      Header: "Election List",
                      accessor: "election_list",
                      filterable: false,
                    },
                    {
                      Header: "Link",
                      accessor: "url",
                      filterable: false,
                    },
                    {
                      Header: "สถานะเปิดใช้งาน",
                      accessor: "active",
                      sortable: false,
                    },
                    {
                      Header: "จัดการ",
                      accessor: "actions",
                      filterable: false,
                      sortable: false,
                    },
                    // {
                    //   Header: "ตั้งค่าต่างๆ",
                    //   accessor: "actions",
                    //   sortable: false,
                    //   filterable: false
                    // }
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  className="-striped -highlight"
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

function mapStateToProps({ listsUserFromImport }) {
  return {
    listsUserFromImport: listsUserFromImport
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsUserFromImportUpdate }
  )
)(UserFromImportListManagement)
